"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODE_UNDO_APPROVE = exports.MODE_APPROVE = exports.MODE_CONTROL = void 0;
var React = require("react");
var Modal = require("react-modal");
require("./ApproveModal.scss");
var ModalMessages;
(function (ModalMessages) {
    ModalMessages["APPROVE"] = "Niet alle dagen zijn gesloten door de medewerker. Weet je zeker dat je deze week wilt goedkeuren?";
    ModalMessages["UNDO_APPROVE"] = "Weet u zeker dat u de goedkeuring voor deze week ongedaan wilt maken?";
    ModalMessages["CONTROL"] = "Niet alle dagen zijn gesloten door de medewerker. Weet je zeker dat je deze week controle wilt hebben?";
})(ModalMessages || (ModalMessages = {}));
;
exports.MODE_CONTROL = 'CONTROL';
exports.MODE_APPROVE = 'APPROVE';
exports.MODE_UNDO_APPROVE = 'UNDO_APPROVE';
var ApproveModal = /** @class */ (function (_super) {
    __extends(ApproveModal, _super);
    function ApproveModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.initialState();
        Modal.setAppElement('#application');
        return _this;
    }
    ApproveModal.prototype.openModal = function () {
        this.setState({
            open: true,
        });
    };
    ApproveModal.prototype.initialState = function () {
        return {
            open: false,
        };
    };
    ApproveModal.prototype.render = function () {
        var _this = this;
        return (React.createElement(Modal, { isOpen: this.state.open, className: "search-projects-modal approve-modal" },
            React.createElement("div", { id: "approve-modal-content" },
                React.createElement("div", { className: "margin-16" }),
                React.createElement("div", { className: "approve-message" }, ModalMessages[this.props.mode]),
                React.createElement("div", { className: "margin-16" }),
                React.createElement("div", { className: "buttons-container row" },
                    React.createElement("button", { className: "button", onClick: function () {
                            _this.setState(_this.initialState());
                            if (_this.props.mode === exports.MODE_CONTROL) {
                                _this.props.onControl();
                            }
                            else if (_this.props.mode === exports.MODE_APPROVE) {
                                _this.props.onApprove();
                            }
                            else {
                                _this.props.onUndoApprove && _this.props.onUndoApprove();
                            }
                        } },
                        this.props.mode === exports.MODE_CONTROL && 'Controleren',
                        this.props.mode === exports.MODE_APPROVE && 'Goedkeuren',
                        this.props.mode === exports.MODE_UNDO_APPROVE && 'Ongedaan maken'),
                    React.createElement("div", { className: "margin-8" }),
                    React.createElement("button", { className: "button button-default", onClick: function () {
                            _this.setState(_this.initialState());
                        } }, "Annuleer")))));
    };
    return ApproveModal;
}(React.Component));
exports.default = ApproveModal;
